import CalendarComponent from 'src/components/calendars';
import { RouteComponentProps } from 'react-router';
import React, { FC, useCallback, useEffect, useState } from 'react';
import AdminLayout from '../../../../../../components/layout/RoleLayout';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import SimpleCalendar from 'src/components/calendars/SimpleCalendar';
import { routes } from '../../../../../../navigation';
import classNames from 'classnames';
import styles from './assets/case-calendar-screen.module.scss';
import Loader from '../../../../../../components/Loader';
import { ICase } from 'src/types/case';
import { ISeance } from 'src/types/seance';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { QueryMultiParams } from '../../../../../../types/grid';
import { Paginated } from '../../../../../../services/api-handlers/pagination';

import moment from 'moment';
import LegendComponent from '../../../../../../components/calendars/LegendComponent';
import { CaseApi } from '../../../../../../services/end-points';
import sortingService from '../../../../../../services/sorting';

export interface StateProps {
    inProgress: boolean;
    inProgressSeance: boolean;
    caseEnt: ICase | null;
    seances: Paginated<ISeance>;
}

export interface DispatchProps {
    getCaseData: (id: string | number) => void;
    getData: (params: QueryMultiParams) => void;
    updateCaseAction: (data: AnyObject) => void;
}

interface RouteParams {
    id: number;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export type OwnProps = RouteComponentProps<RouteParams>;

export interface Props extends StateProps, DispatchProps, OwnProps {}

const CaseCalendarScreen: FC<Props> = (props: Props) => {
    // const myEventsList: any = [];
    const [date, setDate] = useState<Date | null>(new Date());
    const [calendar, setCalendar] = useState<boolean>(false);
    const [month, setMonth] = useState<{ monthEnd: string; monthStart: string } | null>(null);
    const {
        match: {
            params: { id },
        },
        caseEnt,
        inProgress,
        getData,
        inProgressSeance,
        seances,
        getCaseData,
    } = props;

    //let isSameMandateExist = false;
    const [isCheckExist, setIsCheckExist] = useState<boolean>(false);
    const [existData, setExistData] = useState<number>(0);

    useEffect(() => {
        if (
            !isCheckExist &&
            caseEnt &&
            caseEnt?.caseType == 1 &&
            (caseEnt?.orderType == 2 || caseEnt?.orderType == 3)
        ) {
            const providersId: any = [];
            if (caseEnt?.occasionProviders) {
                caseEnt?.occasionProviders.forEach((itProv) => {
                    if (itProv?.provider) {
                        providersId.push(itProv?.provider?.id);
                    }
                });
            }

            const result = CaseApi.getCases({
                'orderEntity.caseNumber': caseEnt?.caseNumber,
                caseType: 1,
                onlyActive: 1,
                orderType: [1, 6],
                'student.id': caseEnt?.student?.id,
                onlyProvider: providersId,
                page: 1,
                itemsPerPage: 1,
                pagination: 1,
            }).then(async (response) => {
                setExistData(response?.data);
                setIsCheckExist(true);
                return response?.data?.length;
            });
        }
        console.log('onlyActive');
    }, [isCheckExist, setIsCheckExist, caseEnt]);

    useEffect(() => {
        console.log(isCheckExist, existData);
        // eslint-disable-next-line
    }, [existData, setExistData]);

    useEffect(() => {
        if (!caseEnt || caseEnt.id !== id) {
            getCaseData(id);
        }
        // eslint-disable-next-line
    }, [getCaseData, getData, id]);
    useEffect(() => {
        if (caseEnt) {
            setDate(new Date(caseEnt?.caseNumberValidityFrom));
            const monthStart = moment(new Date(caseEnt?.caseNumberValidityFrom)).startOf('month').format('YYYY-M-D');
            const endOfDat = moment(new Date(caseEnt?.caseNumberValidityFrom)).startOf('month').toDate();

            endOfDat.setHours(23, 59, 59, 999);
            const monthEnd = moment(new Date(caseEnt?.caseNumberValidityFrom)).endOf('month').format('YYYY-M-D');
            setMonth({
                monthStart,
                monthEnd,
            });
        }
        // eslint-disable-next-line
    }, [caseEnt]);
    useEffect(() => {
        if (caseEnt && `${caseEnt.id}` === `${id}` && month) {
            const providersId: any = [];
            caseEnt.occasionProviders.forEach((itProv) => {
                if (itProv?.provider) {
                    providersId.push(itProv?.provider?.id);
                }
            });
            let client: { [key: string]: number } = { 'student.id': caseEnt?.student?.id ? +caseEnt.student.id : 1 };
            if (caseEnt.district?.id) {
                client = { 'district.id': caseEnt?.district?.id ? +caseEnt.district.id : 1 };
            } else if (caseEnt.vendor?.id) {
                client = { 'vendor.id': caseEnt?.vendor?.id ? +caseEnt.vendor.id : 1 };
            }

            getData({
                page: 1,
                itemsPerPage: 80,
                filters: [
                    {
                        ...client,
                        // seanceDate: [caseEnt.caseNumberValidityFrom, caseEnt.caseNumberValidityTo],
                        //    'seanceDate[before]': moment(caseEnt.caseNumberValidityTo).format('YYYY-M-D'),
                        //    'seanceDate[after]': moment(caseEnt.caseNumberValidityFrom).format('YYYY-M-D'),
                        'seanceDate[after]': month.monthStart,
                        'seanceDate[before]': month.monthEnd,
                    },
                    {
                        'provider.id': providersId,
                        //    'seanceDate[before]': moment(caseEnt.caseNumberValidityTo).format('YYYY-M-D'),
                        //    'seanceDate[after]': moment(caseEnt.caseNumberValidityFrom).format('YYYY-M-D'),
                        'seanceDate[after]': month.monthStart,
                        'seanceDate[before]': month.monthEnd,
                    },
                ],
            });
        }

        // eslint-disable-next-line
    }, [caseEnt, month]);

    const onChangeNav = (date: Date) => {
        const monthStart = moment(date).startOf('month').format('YYYY-M-D');
        const endOfDat = moment(date).startOf('month').toDate();

        endOfDat.setHours(23, 59, 59, 999);
        const monthEnd = moment(date).endOf('month').format('YYYY-M-D');
        setDate(endOfDat);
        setMonth({
            monthStart,
            monthEnd,
        });
    };

    const start: any = new Date(`${props?.caseEnt?.caseNumberValidityFrom}`).getTime() - 120 * 60 * 1000;
    const end: any = new Date(`${props?.caseEnt?.caseNumberValidityTo}`).getTime();
    const onChangeDate = (date: Date | any) => {
        const endOfDat = new Date(`${date}`);

        endOfDat.setHours(12, 59, 59, 999);
        setDate(endOfDat);
    };
    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'CASES', path: routes.CASES_LIST },
                    { name: `CASE CALENDAR`, path: '' },
                ]}
            />

            <div className="d-flex justify-content-center mb-4 flex-row">
                {inProgress || inProgressSeance ? <Loader /> : null}

                <h3 className={classNames(` mr-5 `)}>
                    <Link to={Router.generate(routes.CASE_EDIT, { id })}>Step 1</Link>
                </h3>
                <h3 className={classNames(`${styles.activeTab}  pb-1`)}>Step 2</h3>
            </div>
            <div className={classNames(styles.calendarWrap)}>
                <div className="">
                    <div className={classNames(styles.calendarsTop)}>
                        <LegendComponent />
                        <div className={classNames(styles.calendarMini)}>
                            {calendar ? (
                                <SimpleCalendar
                                    min={start}
                                    setDate={onChangeDate}
                                    containerClassName={classNames(styles.absoluteCalendar)}
                                    max={end}
                                    nowDate={date}
                                    navigateDate={onChangeNav}
                                    open={'date'}
                                />
                            ) : null}
                            <button
                                className={`btn btn-info float-right`}
                                onClick={(e) => setCalendar(!calendar)}
                                type={'button'}
                            >
                                Navigate
                            </button>
                        </div>
                    </div>
                    <div className="w-100">
                        <CalendarComponent
                            caseEnt={caseEnt}
                            seances={seances}
                            change={true}
                            nowDate={date}
                            existData={existData}
                            setExistData={setExistData}
                            setEvent={(data) => props.updateCaseAction({ ...data, id })}
                        />
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default CaseCalendarScreen;
